import React, { useState, useEffect } from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useLanguage } from '../../i18n';
import LeadPopup from '../LeadPopup';

import './style.scss'

const HeroSlider = ({ className }) => {
    const { t } = useLanguage();
    const [showPopup, setShowPopup] = useState(false);

    // Show the consultation popup 3 seconds after the disclaimer has been
    // accepted (never on top of it), once per session. Skipped while
    // react-snap prerenders, so it isn't baked into the static HTML.
    useEffect(() => {
        if (navigator.userAgent === 'ReactSnap' || sessionStorage.getItem('leadPopupClosed')) return undefined;
        let timer;
        const start = () => { timer = setTimeout(() => setShowPopup(true), 3000); };
        if (localStorage.getItem('disclaimerAccepted')) start();
        else window.addEventListener('disclaimer-accepted', start, { once: true });
        return () => {
            clearTimeout(timer);
            window.removeEventListener('disclaimer-accepted', start);
        };
    }, []);

    const settings = {
        dots: true,
        infinite: true,
        arrows: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    const sliders = [
        {
            images: 'slideWrapperOne',
            title: t('hero.slide1Title'),
            subtitle: t('hero.slide1Subtitle'),
            button: t('hero.slide1Button')
        },
        {
            images: 'slideWrapperTwo',
            title: t('hero.slide2Title'),
            subtitle: t('hero.slide2Subtitle'),
            button: t('hero.slide2Button')
        },
        {
            images: 'slideWrapperThree',
            title: t('hero.slide3Title'),
            subtitle: t('hero.slide3Subtitle'),
            button: t('hero.slide3Button')
        },
    ];

    return (
        <>
            <Slider className={className} {...settings}>
                {sliders.map((slider, i) => (
                    <div
                        key={i}
                        className={`slideWrapper ${slider.images}`}
                    >
                        <div className="sliderContent">
                            <div className="container">
                                <div className="row">
                                    <div style={{ textAlign: "center" }}>
                                        <h2 style={{ color: "white" }}>{slider.title}</h2>
                                        <p><span></span><br /><br /><span>{slider.subtitle}</span></p>
                                        <div className="btnStyle">
                                            <a href="#contactArea">{slider.button}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>

            <LeadPopup
                isOpen={showPopup}
                onClose={() => setShowPopup(false)}
            />
        </>
    )
}

export default HeroSlider